import { Button, Typography } from '@cobliteam/ui/components';
import Icon, { type IconNames } from '@cobliteam/ui/icons';
import { Link } from 'react-router-dom';

interface EmptyStateProps {
  iconName: IconNames;
  title: string;
  description: string;
  buttonText?: string;
  onButtonClick?: () => void;
  showButton?: boolean;
  to?: string;
}

export const EmptyState = ({ iconName, title, description, buttonText, onButtonClick, showButton = true, to }: EmptyStateProps) => (
  <div className='flex flex-col items-center gap-5'>
    <Icon size='lg' name={iconName} className='box-content size-10 rounded-full bg-gray-lightest p-5 text-gray' />
    <div className='flex max-w-80 flex-col items-center gap-2.5'>
      <Typography color='secondary'>{title}</Typography>
      <Typography color='secondary' className='text-center'>
        {description}
      </Typography>
    </div>
    {showButton &&
      buttonText &&
      (to ? (
        <Link to={to} className='block' onClick={onButtonClick}>
          <Button size='sm' startIcon={<Icon name='plus' />}>
            {buttonText}
          </Button>
        </Link>
      ) : (
        <Button size='sm' startIcon={<Icon name='plus' />} onClick={onButtonClick}>
          {buttonText}
        </Button>
      ))}
  </div>
);
